import React from "react";
import { Amount } from "../../modification/model";

interface ExtraRenderProps {
  amount: Amount;
  quantity?: number;
}

export function ExtraRender(props: ExtraRenderProps) {
  const { amount, currency } = props.amount;
  if (!props.quantity) {
    return (
      <>
        {amount.toFixed(2)} {currency}
      </>
    );
  }
  const unit = amount / props.quantity;
  return (
    <>
      {props.quantity} x {unit.toFixed(2)} = {amount.toFixed(2)} {currency}
    </>
  );
}
